import { useEffect, useMemo, useState } from 'react';
import { intelligenceApi } from '../lib/adapter';
import type { AIFollowUp } from '../types/contracts';
import { IntelligenceShell } from '../components/IntelligenceShell';
import { FollowUpCard } from '../components/FollowUpCard';
import { EmptyState, ErrorState, Skeleton } from '../components/states';

const TABS: { key: AIFollowUp['status']; label: string }[] = [
  { key: 'today', label: 'اليوم' },
  { key: 'overdue', label: 'متأخرة' },
  { key: 'upcoming', label: 'قادمة' },
  { key: 'completed', label: 'مكتملة' },
];

export default function FollowUpsPage() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [items, setItems] = useState<AIFollowUp[]>([]);
  const [tab, setTab] = useState<AIFollowUp['status']>('today');

  const load = async () => {
    setLoading(true);
    setError('');
    const r = await intelligenceApi.listFollowUps();
    setLoading(false);
    if (!r.ok) { setError('message' in r ? r.message : 'حدث خطأ ما'); return; }
    setItems(r.data);
  };
  useEffect(() => { void load(); }, []);

  const filtered = useMemo(() => items.filter((f) => f.status === tab), [items, tab]);

  const complete = async (fid: string) => {
    await intelligenceApi.completeFollowUp(fid);
    setItems((prev) => prev.map((f) => (f.id === fid ? { ...f, status: 'completed' } : f)));
  };
  const reschedule = async (fid: string) => {
    const due = new Date(Date.now() + 24 * 3600000).toISOString();
    await intelligenceApi.rescheduleFollowUp(fid, due);
    setItems((prev) => prev.map((f) => (f.id === fid ? { ...f, status: 'upcoming', due_at: due } : f)));
  };

  return (
    <IntelligenceShell>
      <div className="mb-4 flex gap-1">
        {TABS.map((tb) => {
          const count = items.filter((f) => f.status === tb.key).length;
          return (
            <button key={tb.key} type="button" onClick={() => setTab(tb.key)}
              className={`px-3 py-1.5 rounded-lg text-xs font-bold ${tab === tb.key ? 'bg-gray-900 text-white' : 'bg-white border border-gray-200 text-gray-600 hover:bg-gray-50'}`}>
              {tb.label} <span className="opacity-60">({count})</span>
            </button>
          );
        })}
      </div>
      {loading ? <Skeleton rows={4} /> : null}
      {error ? <ErrorState message={error} onRetry={() => void load()} /> : null}
      {!loading && !error && filtered.length === 0 ? (
        <EmptyState title="لا توجد متابعات في هذا التصنيف" body="قائمة مهام المساعد لهذا التصنيف فارغة." />
      ) : null}
      <div className="space-y-2">
        {!loading && !error && filtered.map((f) => (
          <FollowUpCard key={f.id} item={f} onComplete={(fid) => void complete(fid)} onReschedule={(fid) => void reschedule(fid)} />
        ))}
      </div>
    </IntelligenceShell>
  );
}
